module.exports = __webpack_public_path__ + "img/1588429759.a294db69.jpg";